import React, { useState, useRef } from "react";
import { DateTime } from "luxon";
import { getLightColour, getTitle, getIcon, getLink } from "../Components/Util";

export default function TitleCell(props) {
  const [size, setSize] = useState({
    width: 1,
    height: 1,
  });
  const myDiv = useRef();

  new ResizeObserver((div) => {
    if (myDiv) {
      if (myDiv.current) {
        if (myDiv.current.clientHeight) {
          let newHeight = myDiv.current.clientHeight;
          let newWidth = myDiv.current.clientWidth;
          if (newWidth !== size.width || newHeight !== size.height) {
            setSize({ width: newWidth, height: newHeight });
          }
        }
      }
    }
  }).observe(document.querySelector("div"));

  let date = "";
  if (props.date) {
    date = DateTime.fromMillis(props.date, {
      zone: "Canada/Mountain",
    }).toLocaleString(DateTime.DATETIME_FULL);
  }

  function getLogo() {
    if (getIcon() !== "") {
      return (
        <img
          className="titleBarImage"
          src={process.env.PUBLIC_URL + "/icons/" + getIcon()}
          alt=""
          onClick={() => window.open(getLink(), "_blank")}
        />
      );
    } else {
      return <></>;
    }
  }

  return (
    <div
      className="cell titleBar"
      style={{ backgroundColor: getLightColour() }}
      ref={myDiv}
    >
      <div
        style={{
          fontWeight: "bold",
          fontSize: size.height * 0.4 + "px",
          position: "absolute",
          top: size.height * 0.1 + "px",
          left: size.height * 0.3 + "px",
        }}
      >
        {getTitle()}
      </div>
      <div
        style={{
          fontStyle: "italic",
          fontSize: size.height * 0.25 + "px",
          position: "absolute",
          top: size.height * 0.6 + "px",
          left: size.height * 0.3 + "px",
        }}
      >
        Updated: {date}
      </div>
      {getLogo()}
    </div>
  );
}
